import React from 'react';
import Select, { MultiValue, SingleValue } from 'react-select';
import CustomOption from './chechboxindex';
import './SearchableDropDownSmallComponent.css';
import InfoBar from '../InfoBars';
interface OptionType {
  value: string;
  label: string;
}
interface DropDownProps {
  dropDownType?: 'error' | 'success' | 'entered' | 'general';
  options: OptionType[];
  placeHolder?: string;
  onChange: (value: string | string[] | OptionType | null) => any;
  onInputChange?: (value:string) => any;
  multipleSelection: boolean;
  dropDownDisable: boolean;
  afterFocus?: string;
  dropLabelName?: string;
  ifRequired?: boolean;
  className?: string;
  dropdownsearchable: boolean;
  defaultValue?: string | any;
  value?: any;
  style?: any;
  isClearable? : boolean
  errorMessage?:string
}
const SearchableDropdownSmallComponent: React.FC<DropDownProps> = ({
  dropDownType,
  options,
  placeHolder,
  onChange,
  onInputChange,
  multipleSelection,
  dropDownDisable,
  afterFocus,
  dropLabelName,
  ifRequired,
  className,
  dropdownsearchable,
  value,
  style,
  isClearable= true,
  defaultValue,
  errorMessage
}) => {

  const handleSearch = (e:any) =>{
    if (onInputChange) {
      onInputChange(e);
    }
  }

  const handleDropdownChange = (
    selectedOptions: MultiValue<OptionType> | SingleValue<OptionType>,
  ) => {
    multipleSelection
      ? onChange(
          (selectedOptions as MultiValue<OptionType>).map(
            (option) => option.value,
          ),
        )
      : onChange(selectedOptions as SingleValue<OptionType>);
  };
  {
    if (dropDownType === 'error') {
      afterFocus = 'red';
    } else if (dropDownType === 'success') {
      afterFocus = 'green';
    } else if (dropDownType === 'entered') {
      afterFocus = 'blue';
    } else {
      afterFocus = '';
    }
  }
  return (
    <div className='multi_select_searchable_dropdown_small'>
    <div className={`multi-select-group-${dropDownType} ${className}`}>
      {dropLabelName && (
        <label
          className={`drop-name-required-for-ip ${ifRequired && 'yes'} ${dropDownDisable}`}
        >
          {dropLabelName}
        </label>
      )}
      <Select
        className={`multi-select-dropdown ${dropDownDisable} `}
        classNamePrefix="multi-select"
        isMulti={multipleSelection}
        options={options}
        placeholder={placeHolder}
        components={multipleSelection ? { Option: CustomOption } : undefined}
        closeMenuOnSelect={!multipleSelection}
        hideSelectedOptions={false}
        onChange={handleDropdownChange}
        onInputChange={handleSearch}
        isDisabled={dropDownDisable}
        isSearchable={dropdownsearchable}
        defaultValue={defaultValue}
        value={value}
        isClearable={isClearable}
        styles={{
          placeholder: (baseStyles) => ({
            ...baseStyles,
            marginLeft: 10,
            color: 'rgba(179, 179, 179, 1)',
            fontWeight: 400,
            fontSize: 12,
          }),
          valueContainer: (baseStyles) => ({
            ...baseStyles,
            // display: 'flex',
            // alignItems:'center',
            flexWrap: 'nowrap',
            overflow: 'overlay',
            marginLeft: 7,
          }),
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: state.isFocused ? afterFocus : 'grey',
            '&:hover': {
              borderColor: state.isFocused ? afterFocus : 'grey',
            },
            flexWrap: state.isFocused ? 'nowrap' : 'nowrap',
            boxShadow: state.isFocused ? 'none' : 'none',
          }),
          ...style
        }}
      />
      <div className="searchable_drop_down_infoBars">
        {dropDownType === 'success' ? (
          <InfoBar
            variant="success"
            message={errorMessage?errorMessage:''}
            className="searchable_drop_down_class"
          />
        ) : (
          ''
        )}
        {dropDownType === 'error' ? (
          <InfoBar
            variant="danger"
            message={errorMessage?errorMessage:''}
            className="searchable_drop_down_class"
          />
        ) : (
          ''
        )}
      </div>
    </div>
    </div>
  );
};

export default SearchableDropdownSmallComponent;
